export default __webpack_public_path__ + "static/media/bw-executive-function-tutorial-pop-up-step-2_en.f6e98a96.svg";